// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles-module--footer--3aAW0","footerDark":"styles-module--footer-dark--1jt6j"};